import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl';
import App from './App';
import generateStore from './services/store/store';
import reportWebVitals from './reportWebVitals';

const store = generateStore();

ReactDOM.render(
  <IntlProvider locale="es">
    <Provider store={store}>
      <App />
    </Provider>
  </IntlProvider>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
